import React from 'react';
import { cn } from '../../utils/cn';

export interface FormFieldProps {
  label: string;
  error?: string;
  hint?: string;
  htmlFor?: string;
  required?: boolean;
  children: React.ReactNode;
  className?: string;
}

const FormField: React.FC<FormFieldProps> = ({ label, error, hint, htmlFor, required = false, children, className }) => {
  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      <label htmlFor={htmlFor} className="text-sm font-medium text-[var(--foreground)]">
        {label}
        {required && <span className="text-[var(--destructive)]" aria-hidden="true"> *</span>}
      </label>
      {children}
      {error && <p className="text-sm text-[var(--destructive)]">{error}</p>}
      {!error && hint && <p className="text-sm text-[var(--muted-foreground)]">{hint}</p>}
    </div>
  );
};

export default FormField;
